export default __webpack_public_path__ + "static/media/eft.a09a71a0.svg";